import styled from "styled-components";

export const Container = styled.div `

    margin-top: 30px;
    
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
    }

    header h2 {
        margin: 0 !important;
    }
    
    header div {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .div-select-season .title-episodes-mobile {
            display: none;
    }

    .div-select-season .title-episodes-desktop {
        display: flex;
    }

    .div-select-season button {
        background: unset;
        color: #fff;
        height: 40px;
        width: 40px;
        margin-right: 5px;
        border-radius: 50px;
        border: none;
        cursor: pointer;
        font-size: 1.1rem;
        transition: all .3s ease;
    }

    .div-select-season button:hover {
        background: #303030;
    }

    .div-select-season button:first-child {
        margin-right: 5px;
    }

    header .active {
        background: #fff;
        color: #181818;
    }

    header .active:hover {
        cursor: default;
        background: #fff;
    }

    .next-previous-season {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        justify-content: space-between;
        margin-bottom: 50px;
        gap: 10px;
    }

    .next-previous-season button {
        background: #303030;
        color: #fff;
        border-radius: 5px;
        padding: 30px 15px;
        border: none;
        cursor: pointer;
        font-weight: 600;
        font-size: .9rem;
        transition: all .3s ease;
    }

    .next-previous-season button:hover {
        background: #404040;
    }

    .next-previous-season button:first-child i {
        margin-right: 10px;
    }

    .next-previous-season button:last-child i {
        margin-left: 10px;
    }

    .container-episodes {
        display: ${props => props.layoutStyle == 'grid' ? 'grid' : 'flex'};
        flex-direction: column;
        grid-template-columns: repeat(4, 1fr);
        gap:  ${props => props.layoutStyle == 'grid' ? '10px' : '0'};
    }

    .div-select-season {
        display: flex;
        align-items: center;
    }

    .container-episode:last-child {
        border: none;
    }

    .container-episode {
        position: relative;
        border-bottom: ${props => props.layoutStyle == 'grid' ? 'none' : '2px solid #505050'};
    }

    .episode {
        display: ${props => props.layoutStyle == 'grid' ? 'block' : 'flex'};
        color: #fff;
        text-decoration: none;
        padding: ${props => props.layoutStyle == 'grid' ? '10px' : '10px'};
        border-radius: 5px;
        transition: all .3s ease;
    }

    .episode:hover {
        background: #00000070;
    }

    .container-episode:hover .button-change-watched, .button-change-watched:focus {
        opacity: 1 !important;
    }

    .div-watched-example div {
        margin-right: 15px;
    }

    .div-watched-example div span {
        font-weight: 600;
        font-size: .9rem;
    }
    
    .button-change-watched-example {
        width: 30px;
        height: 30px;
        cursor: default;
        font-size: .7rem;
        border-radius: 50px;
        background: #00000090;
        margin-right: 5px;
        color: #fff;
        border: 2px solid #ffffffaa;
        transition: all .5s ease;
    }

    .button-watched-example {
        background: #fff;
        border: 2px solid #000;
        color: #000;
    }

    .button-change-watched {
        position: absolute;
        top: ${props => props.layoutStyle === 'grid' ? '20px' : '15px'};
        right: ${props => props.layoutStyle === 'grid' ? '20px' : 'auto'};
        left: ${props => props.layoutStyle === 'grid' ? 'auto' : '16px'};
        width: ${props => props.layoutStyle == 'grid' ? '45px' : '30px'};
        height: ${props => props.layoutStyle == 'grid' ? '45px' : '30px'};
        font-size: ${props => props.layoutStyle == 'grid' ? '1rem' : '.7rem'};
        cursor: pointer;
        border-radius: 50px;
        background: #00000090;
        color: #fff;
        border: 2px solid #ffffffaa;
        opacity: 0;
        transition: all .5s ease;
    }

    .button-change-watched:hover {
        background: #0c92a6;
        border: 2px solid #fff;
        color: #fff;
    }

    .button-watched {
        background: #fff;
        border: 2px solid #000;
        color: #000;
    }

    .button-watched:hover {
        background: #f00;
        border: 2px solid #fff;
        color: #fff;
    }

    .container-image {
        position: relative;
    }

    .container-image img {
        border-radius: 5px;
        min-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '200px'};
        max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '200px'};
        width: 100%;
        height: auto;
        background-color: #252525;
        aspect-ratio: 16/9;
        object-fit: cover;
    }
    
    .section-info-watching {
        position: absolute;
        bottom: 4px;
        left: 0;
        width: 100%;
    }

    .div-porcentos-assistidos {
        position: relative;
        min-width: 100%;
        overflow: hidden;
        background: #606060;
        height: 5px;
    }

    .div-porcentos-assistidos div {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0px;
        height: 5px;
        background: #f00;
    }

    .episode .details {
        width: 100%;
        margin-left: ${props => props.layoutStyle == 'grid' ? '' : '20px'};
    }

    .episode .details section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 5px 0 10px 0;
    }

    .episode .details .name {
        font-size: 1.1rem;
        overflow: hidden;
        font-weight: bold;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        margin-right: 10px;
        -webkit-box-orient: vertical;
    }

    .episode .details section span {
        margin-right: 10px;
        font-size: .85rem;
        font-weight: 600;
        color: #fff;
        white-space: nowrap;
    }

    .episode .details .name span {
        margin-right: 5px;
        font-size: .8rem;
    }

    .episode .details .overview {
        font-size: .85rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        color: #fff;
        -webkit-box-orient: vertical;
    }

    .section-more-movies {
        
        background-image: linear-gradient(0deg, #202020, #202020e0, #20202000);
        display: flex;
        justify-content: center;
        margin-top: -200px;
        padding: 100px 0;
        position: relative;
        z-index: 2;
        
    }

    .section-more-movies button {
        background: #181818b3;
        color: #fff;
        align-items: center;
        border: 2px solid #aaa;
        border-radius: 50px;
        cursor: pointer;
        display: flex;
        height: 38px;
        justify-content: center;
        margin-right: 10px;
        transition: all .2s ease;
        width: 38px;
    }

    .section-more-movies button:hover {
        background: #404040;
        border: 2px solid #fff;
    }

    @media (max-width: 1200px) {

        .container-episodes {
            grid-template-columns: repeat(3, 1fr);
        }

    }

    @media (max-width: 1000px) {

        .container-episodes {
            grid-template-columns: repeat(2, 1fr);
        }

        .episode {
            padding: ${props => props.layoutStyle == 'grid' ? '10px' : '10px'};
        }

        .episode img {
            min-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '200px'};
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '200px'};
        }

        .episode .details {
            margin-left: ${props => props.layoutStyle == 'grid' ? '' : '20px'};
        }

        .episode .details .name {
            font-size: 1rem;
        }

        .episode .details section span {
            font-size: .7rem;
        }

        .episode .details .overview {
            font-size: .75rem;
        }

    }

    @media (max-width: 800px) {

        .episode img {
            min-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '160px'};
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '160px'};
        }

        .episode .details .name {
            margin-top: 0 !important;
        }

        .button-change-watched {
            opacity: 1 !important;
        }

    }

    @media (max-width: 600px) {
            
        header {
            flex-direction: column;
            align-items: start;
        }

        .container-select-season {
            justify-content: space-between;
            margin-top: 10px;
            width: 100%;
        }

        header button {
            height: 30px;
            width: 30px;
            font-size: .9rem;
        }

        .div-select-season .title-episodes-mobile {
            display: flex;
        }

        .div-select-season button, .title-episodes-desktop {
            display: none;
        }

        .div-watched-example {
            display: flex;
            justify-content: space-between;
            width: 100%;
        }

        .div-watched-example div span {
            font-size: .8rem;
        }

        .button-change-watched {
           top: 25px;
           left: 10px;
        }

        .episode {
            padding: ${props => props.layoutStyle == 'grid' ? '10px' : '20px 5px'};
        }

        .container-image img {
            border-radius: 3px;
        }

        .episode img {
            min-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '140px'};
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '140px'};
        }

        .div-porcentos-assistidos {
            height: 3px;
        }

        .div-porcentos-assistidos div {
            height: 3px;
        }

        .episode .details {
            margin-left: ${props => props.layoutStyle == 'grid' ? '' : '10px'};
        }

        .episode .details .name {
            font-size: .85rem;
        }

        .episode .details section span {
            font-size: .65rem;
        }

        .episode .details .overview {
            font-size: .65rem;
        }

    }

    @media (max-width: 550px) {

        .container-episodes {
            grid-template-columns: repeat(1, 1fr);
            gap:  ${props => props.layoutStyle == 'grid' ? '5px' : '0'};
        }

        .episode {
            padding: ${props => props.layoutStyle == 'grid' ? '5px' : '15px 5px'};
        }

        .episode img {
            aspect-ratio: 16/9;
            min-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '120px'};
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '120px'};
        }

        .episode .details .name {
            font-size: .8rem;
        }

        .episode .details section {
            margin: 0 0 5px 0;
        }

        .episode .details section span {
            font-size: .6rem;
        }

        .episode .details .overview {
            font-size: .6rem;
        }

    }

    @media (max-width: 360px) {
        
        .div-watched-example div span {
            font-size: .65rem;
        }

    }

`

export const SeasonSelectorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 20px;
`;

export const SeasonSelect = styled.select`
    padding: 10px;
    border: 2px solid #00000030;
    background-color: #00000070;
    color: #fff;
    font-size: 1rem;
    border-radius: 5px;
    outline: none;
    transition: border-color 0.3s;

    &:hover {
        border: 2px solid #00000070;
    }

    &:focus {
        border: 2px solid #fff;
    }

    option {
        background-color: #222;
        color: #fff;
    }
`;